import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import PoliciesDiscountDetail from './components/PoliciesDiscountDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManagePoliciesDiscount',
  components: {
    PoliciesDiscountDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;